import { emitSearchResultsEvent } from 'store/search/searchActions';
import { emitDealsPageResults } from 'store/deal/dealActions';
import { emitRecommendedPropertiesResult } from 'store/recommendedProperty/recommendedPropertyActions';
import { emitPromoAreaGa4Results } from 'store/promoArea/promoAreaActions';
import { createViewItemListEvent } from '../eventCreators';
import { createViewItemListEventPayload } from '../dataHelpers/createViewItemListEventPayload';

const emitViewItemListEvent = ({ payload }) => {
  return createViewItemListEvent(
    createViewItemListEventPayload({
      type: payload?.type,
      listName: payload?.listName,
      location: payload?.query?.location || payload?.query?.regionName,
      category: payload?.category,
      payWith: payload?.query?.payWith,
      availableProperties: payload?.results?.length,
      availableRooms: payload?.results?.length,
      checkIn: payload?.query?.checkIn,
      checkOut: payload?.query?.checkOut,
      adults: Number(payload?.query?.adults) || 0,
      children: Number(payload?.query?.children) || 0,
      infants: Number(payload?.query?.infants) || 0,
      currency: payload?.currency,
      hasOffer: payload?.hasOffer,
      results: payload?.results,
      quantity: payload?.quantity,
      pointsConversion: payload.pointsConversion,
      pageType: payload.pageType,
    }),
  );
};

export default {
  [emitDealsPageResults]: emitViewItemListEvent,
  [emitSearchResultsEvent]: emitViewItemListEvent,
  [emitRecommendedPropertiesResult]: emitViewItemListEvent,
  [emitPromoAreaGa4Results]: emitViewItemListEvent,
};
